import { render, staticRenderFns } from "./PanelResumeBio.vue?vue&type=template&id=7e4895d8&"
import script from "./PanelResumeBio.vue?vue&type=script&lang=js&"
export * from "./PanelResumeBio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports